import React from 'react';
import CreateContent from "./create-content.jsx";
import UpdateContent from "./update-content.jsx";
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const AuditContent = ({element}) => {
    const navigate = navigateHook();

    return (
        <table className="table mb-4 audit-content-table">
            <thead style={{background: "#F2F2F2"}}>
                <tr className='text-left'>
                    <th style={{width: "15%"}}>ID</th>
                    <th style={{width: "15%"}}>Ação</th>
                    <th style={{width: "25%"}}>Agente</th>
                    <th style={{width: "55%"}}>Data/hora</th>
                </tr>
            </thead>

            <tbody>
                <tr className='text-left'>
                    <td><a onClick={() => navigate(`/despacho/dispatch/form/${element?.id}`, true)} rel="noreferrer" className={'report-link'}>{element?.id}</a></td>
                    <td>{element?.action}</td>
                    <td>{element?.user}</td>
                    <td>{element?.date}</td>
                </tr>

                { element?.action !== "Visualização" && (
                    ((element?.action === 'Cadastro' || element?.action === 'Exclusão') ? <CreateContent element={element}/> : <UpdateContent element={element}/>) ?? ''
                )}
            </tbody>
        </table>
    );
};

export default AuditContent;